import React from 'react'

import FormAddDeprecated from "../../../../gd-form/form/deprecated/form-add/form-add"
import FormManager from '../../../../gd-form/common/form-manager'
import FormError from '../../../../gd-form/common/form-error/form-error'
import Input from '../../../../gd-form/form-element/input/input'
import CopyOption from '../copy-project/copy-options/copy-option'
import VScroll from '../../../../gd-components/scrolling/custom-v-scroll/v-scroll'
import SelectParentNew from "../../../../gd-ui/select-parent-new/select-parent-new"
import {EntityType} from "../../../../gd/const/item"
import {SelectParent_RenderType} from "../../../../gd-ui/select-parent-new/@const"
import {Copy_Manager} from "../../model/manager"
import {ModalCopy_CopyOption} from "../../@types"
import {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import Modal_Submit from "../../../components/submit/submit"
import {CopyTasks_Manager} from "../../model/copy-tasks-manager"
import {ModalCopy_Task_CopyOptionId} from "./copy-task"

type Props = {
    manager : Copy_Manager
}

// const debug = "ModalCopy_Tasks"
const debug = false

export default function ModalCopy_Tasks(props: Props) {

    const manager = props.manager as CopyTasks_Manager
    const tasksToCopy = manager.tasksToCopy!

    const onSubmit = (result: any) => {
        if (result.copyOptions.includes(ModalCopy_Task_CopyOptionId.USERS)) {
            manager.validateUsers(result)
        } else {
            if (result.copyOptions.includes(ModalCopy_Task_CopyOptionId.ASSIGNEE)) {
                manager.validateUsers(result)
            } else {
                manager.commitCopy(result)
            }
        }

    }

    const copyOptions: ModalCopy_CopyOption[] = [
        {id: ModalCopy_Task_CopyOptionId.DESCRIPTION,    title: "Task description"},
        {id: ModalCopy_Task_CopyOptionId.TAGS,           title: "Tags"},
        {id: ModalCopy_Task_CopyOptionId.NOTES,          title: "Notes"},
        {id: ModalCopy_Task_CopyOptionId.CUSTOM_FIELDS,  title: "Custom field values"},
        {id: ModalCopy_Task_CopyOptionId.USERS,          title: "Users"},
        {id: ModalCopy_Task_CopyOptionId.ASSIGNEE,       title: "Assignee"},
    ]


    const parentProject = tasksToCopy[0].projectId
    const initFormData = {
        titlePostfix           : " - copy",
        parentProject   : parentProject,

        copyOptions     : [
            ModalCopy_Task_CopyOptionId.DESCRIPTION,
            ModalCopy_Task_CopyOptionId.TAGS,
            ModalCopy_Task_CopyOptionId.NOTES,
            ModalCopy_Task_CopyOptionId.CUSTOM_FIELDS,
            ModalCopy_Task_CopyOptionId.USERS,
            ModalCopy_Task_CopyOptionId.ASSIGNEE,
        ]
    }

    const formStructure = {
        isFormChanged: true,
        fields: {
            titlePostfix: {
                type: 'select',
                isRequired: false,
            },
            parentProject: {
                type: 'select',
                isRequired: true,
            },
            copyOptions: {
                type: 'select',
                isRequired: false,
            }
        },
        onSubmit: onSubmit
    };

    const form = new FormManager(formStructure, initFormData);

    const onParentSelected = (projectId: ID) => {
        form.setFieldValue("parentProject", projectId)
    }

    const onCopyOptionSelect = (id: ID) => {
        let newSelectedOptions = form.getValue('copyOptions')
        newSelectedOptions = gd.utils.toggleArrayValue(newSelectedOptions,id)
        form.setValue('copyOptions', newSelectedOptions)
    }

    const projectId         = form.getValue('parentProject')
    const selectedOptions   = form.getValue('copyOptions')


    return (
         <div className="flex-column-top-stretch flex-1 min-h-0">
             <FormAddDeprecated className  = "flex-row-left-top flex-1"
                                style      = {{height: 'calc(100% - 50px - 90px)'}}
                                form       = {form}
                                showSubmit = {false}>
                 <VScroll>
                     <div className="tbl">

                         <div className="row">
                             <div className="label">Task title postfix</div>
                             <div className="element">
                                 <Input size="big" form={form} name="titlePostfix"/>
                                 <FormError form={form} name="titlePostfix" />
                             </div>
                         </div>


                         <div className="row">
                             <div className="label">Project</div>
                             <div className="element">
                                 <SelectParentNew projectId  = {projectId}
                                                  parentsFor = {EntityType.TASK}
                                                  renderType = {SelectParent_RenderType.FORM}
                                                  canBeNull  = {gd.spaces.projects.enabled}
                                                  onChange   = {onParentSelected}/>
                                 <FormError form={form} name="parentProject"/>
                             </div>
                         </div>


                         <div className="row">
                             <div className="label">Copy</div>
                             <div className="element">
                                 {copyOptions.map(o=>
                                     <CopyOption key         = {o.id}
                                                 id          = {o.id}
                                                 title       = {o.title}
                                                 selected    = {selectedOptions.includes(o.id)}
                                                 onSelect    = {onCopyOptionSelect}/>)}
                             </div>
                         </div>


                     </div>
                 </VScroll>
             </FormAddDeprecated>

             <Modal_Submit type      = {ButtonType.PRIMARY}
                           label     = "Copy"
                           onSubmit  = {()=>{form.onSubmitClick()}}/>
         </div>

    )
}
